import { render, staticRenderFns } from "./UnreportCommunity.vue?vue&type=template&id=1b484d3a&scoped=true"
import script from "./UnreportCommunity.vue?vue&type=script&lang=js"
export * from "./UnreportCommunity.vue?vue&type=script&lang=js"
import style0 from "./UnreportCommunity.vue?vue&type=style&index=0&id=1b484d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b484d3a",
  null
  
)

export default component.exports